import { CircularProgress, styled, Typography } from '@mui/material';
import React from 'react';

import { useFetchData } from '../../../hooks/useFetchData';
import { ProjectScopeAreaType, ProjectWithLastScanned } from '../../../Types/dealGPT';
import { analysisScopesPathUrl } from '../../../util/routesUrls';
import ConflictReport from '../PhaseTwo/ConflictReport/ConflictReport';
import ScopeAreaDetail from '../PhaseTwo/ScopeAreaDetail';

const ScopeAreaContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  backgroundColor: '#ffffff',
  justifyContent: 'flex-start',
  marginBottom: '150px',
});

const ScopeAreaListItemsContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',

  '& > div:not(:last-child)': {
    borderBottom: '1px solid #C4C4C4',
  },
});

const ReportContainer = styled('div')({
  width: '100%',
  marginTop: '40px',
});

type ScopeAreasProps = {
  project: ProjectWithLastScanned;
};

const ScopeAreas = ({ project }: ScopeAreasProps): JSX.Element => {
  const { data: projectScopeAreas, loading: loadingProjectScopeAreas } = useFetchData<
    ProjectScopeAreaType[]
  >({
    urlPath: analysisScopesPathUrl(project.projectType, project.id),
  });

  return (
    <ScopeAreaContainer>
      <div style={{ width: '100%' }}>
        <Typography sx={{ fontSize: '22px' }}>Scope Area</Typography>
      </div>
      {loadingProjectScopeAreas ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: '20px',
            width: '100%',
            margin: '20px 0',
          }}
        >
          <CircularProgress sx={{ margin: 'auto' }} />
          <Typography align="center">
            This can occasionally take 20-30 seconds as our servers warm up, but will be fast after
            that. Thank you for your patience.
          </Typography>
        </div>
      ) : (
        <>
          <ScopeAreaListItemsContainer>
            {projectScopeAreas &&
              projectScopeAreas.length > 0 &&
              projectScopeAreas.map((scopeArea: ProjectScopeAreaType, index) => (
                <ScopeAreaDetail
                  key={scopeArea.scope + index}
                  scopeArea={scopeArea}
                  projectId={project.id}
                />
              ))}
          </ScopeAreaListItemsContainer>
          {!projectScopeAreas ||
            (projectScopeAreas.length === 0 && (
              <div style={{ marginTop: '15px' }}>
                <Typography sx={{ fontSize: '16px', fontWeight: '400' }}>
                  No scope areas found
                </Typography>
              </div>
            ))}
          <ReportContainer>
            <Typography sx={{ fontSize: '22px', marginBottom: '5px' }}>Reports</Typography>
            <ConflictReport projectId={project.id} />
          </ReportContainer>
        </>
      )}
    </ScopeAreaContainer>
  );
};

export default ScopeAreas;
